import { render } from "./UserEdit.vue?vue&type=template&id=2fea9a06&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=2fea9a06&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fea9a06"]])

export default __exports__